import Address from "./address";
import PostalAddress from "./postal-address";
import { IsEmail, Length, Matches, Validate, ValidateNested, ValidateIf } from 'class-validator';
import { IsPESEL } from "./validator/pesel-validator";
import { IsREGON } from "./validator/regon-validator";

class Insurer {

    type: number = 1;

    @ValidateIf(o => o.type === 1)
    @Length(1, 50)
    firstName: string = '';

    @ValidateIf(o => o.type === 1)
    @Length(1, 50)
    lastName: string = '';

    @ValidateIf(o => o.type === 2)
    @Length(1, 100)
    companyName: string = '';

    @ValidateIf(o => o.type === 1)
    @Validate(IsPESEL)
    PESEL: string = '';

    @ValidateIf(o => o.type === 2)
    @Validate(IsREGON)
    REGON: string = '';

    @IsEmail()
    email: string = '';

    @Matches(RegExp(/^\+?([0-9][- ]?)+[0-9]$/))
    phoneNumber: string = '';

    @ValidateNested()
    address: Address;

    @ValidateIf(o => !o.postalAddressSameAsAddress)
    @ValidateNested()
    postalAddress: PostalAddress;

    postalAddressSameAsAddress: boolean = true;

    constructor() {
        this.address = new Address();
        this.postalAddress = new PostalAddress();
    }
}

export default Insurer;